import { Components } from 'api/gen/client'
import Big from 'big.js'
import { sumLinesExclTax } from './invoiceCalculations'

const DECIMAL_PLACES = 2

interface InvoiceTotals {
  total: string
  tax: string
  subtotal: string
}

const resolveInvoiceTotals = (
  total: string | null,
  tax: string | null,
  invoiceLines: Components.Schemas.InvoiceLine[]
): InvoiceTotals => ({
  total: total ?? invoiceLines.reduce((sum, line) => sum.plus(line.price), Big(0)).toFixed(DECIMAL_PLACES),
  tax: tax ?? invoiceLines.reduce((sum, line) => sum.plus(line.tax), Big(0)).toFixed(DECIMAL_PLACES),
  subtotal: Big(sumLinesExclTax(invoiceLines)).toFixed(DECIMAL_PLACES),
})

export default resolveInvoiceTotals
